import React from 'react'
import Link from 'next/link'
import { useForm } from 'react-hook-form'
import { useRouter } from 'next/router'
import { uuid } from 'uuidv4'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Alert from '../../Shared/Alert/Alert'
import Button_loading from '../../Shared/Loader/Button_loading'
import {
  auth_cookie_name,
  cookies_domain_name,
  default_site_url,
  refresh_cookie_name,
  uuid_cookie_name,
} from '../../../constant/url'
import { deleteCookie, setCookie } from 'cookies-next'
import { encryptDataWithAES } from '../../../constant/functions'

const Forgot_password = ({ isEmailSent }) => {
  const router = useRouter()
  const redirect_url = router.query.to || '/'

  // Alert

  const [isSuccess, setIsSuccess] = useState(isEmailSent)
  const [open_alert, setOpenAlert] = useState(false)
  const [message, setMessage] = useState('')
  const [alert_type, setAlert_type] = useState('success')

  //
  const [isLoading, setIsLoading] = useState(false)

  // react hook form
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  //

  // Submit login form
  const onSubmit = (data) => {
    setIsLoading(true)
    axios
      .post('/api/init_reset', {
        email: data.email,
      })
      .then((res) => {
        setIsLoading(false)
        setIsSuccess('true')
        setCookie('forgot_pass_link_sent', true, {
          maxAge: 60 * 6 * 24,
          domain: cookies_domain_name,
          path: '/',
        })
      })
      .catch((err) => {
        const message = err?.response?.data?.message
        setIsLoading(false)
        if (message) {
          setOpenAlert(true)
          setAlert_type('error')
          setMessage(
            'Looks like there is no account matching the email address provided. Not to worry, you can enter valid email.'
          )
        } else {
          if (message) {
            setOpenAlert(true)
            setAlert_type('error')
            setMessage(
              'Looks like there is no account matching the email address provided. Not to worry, you can enter valid email.'
            )
          }
        }
      })
  }

  return (
    <>
      {/* Alert */}
      <Alert
        className={` w-full md:w-[400px] lg:w-[450px]   fixed bottom-0 md:bottom-5   right-0 z-[99999999999999999999999999999999999999999] `}
        type={alert_type}
        open={open_alert}
        setOpen={setOpenAlert}
      >
        <p>{message}</p>
      </Alert>
      <section className="bg-gradient-to-b from-gray-100 to-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className=" pb-12 pt-8 md:pb-20">
            {/* Page header */}
            <div className="max-w-3xl mx-auto text-center   pb-10">
              {isSuccess && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-16 h-16 text-primary mx-auto mb-2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              )}

              <h1 className="h1 mb-4">
                {isSuccess
                  ? 'Check your email for instructions to reset your password.'
                  : 'Reset your password'}
              </h1>
              <p className="text-xl text-gray-600">
                {isSuccess ? (
                  <span>
                    If you haven't received an email in 5 minutes, check your spam or
                    <i
                      className="text-primary underline  cursor-pointer ml-1"
                      onClick={() => {
                        deleteCookie('forgot_pass_link_sent', {
                          domain: cookies_domain_name,
                          path: '/',
                        })
                        setIsSuccess(false)
                      }}
                    >
                      try again
                    </i>
                    .
                  </span>
                ) : (
                  `Enter the email address associated with your account and we'll send you a link to reset your password.`
                )}
              </p>
            </div>

            {/* Form */}
            <div className="max-w-sm mx-auto">
              {!isSuccess && (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="flex flex-wrap -mx-3 mb-4">
                    <div className="w-full px-3">
                      <label
                        className="block text-gray-800 text-sm font-medium mb-1"
                        htmlFor="name"
                      >
                        Email
                        <span className="text-red-600">*</span>
                      </label>
                      <input
                        id="name"
                        type="text"
                        className="form-input w-full text-gray-800"
                        placeholder="Enter your email"
                        {...register('email')}
                        required
                      />
                    </div>
                  </div>

                  <div className="flex flex-wrap -mx-3 mt-6">
                    <div className="w-full px-3">
                      <button
                        type="submit"
                        disabled={isLoading}
                        className={`btn text-white bg-blue-600 hover:bg-blue-700 w-full flex items-center justify-center gap-4 ${
                          isLoading && 'cursor-not-allowed'
                        }`}
                      >
                        <span>Submit</span>
                        {isLoading && <Button_loading text_color={'text-white'} />}
                      </button>
                    </div>
                  </div>
                  <div className="text-sm text-gray-500 text-center mt-3">
                    By creating an account, you agree to the{' '}
                    <a className="underline" href="/terms-conditions" target={'_blank'}>
                      terms & conditions
                    </a>
                    , and our{' '}
                    <a className="underline" href="/privacy-policy" target={'_blank'}>
                      privacy policy
                    </a>
                    .
                  </div>
                </form>
              )}

              <div className="text-gray-600 text-center mt-6">
                <Link href="/signin">
                  <a className="text-blue-600 hover:underline transition duration-150 ease-in-out">
                    Return to sign in
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Forgot_password
